module.exports = __webpack_public_path__ + "img/flip.a094f73c.svg";